import React from 'react';

const MatchupHeader = ({ gameData }) => {
  const away = gameData?.teams?.away;
  const home = gameData?.teams?.home;
  const venue = gameData?.venue?.name || '--';
  const dateStr = gameData?.datetime?.dateTime
    ? new Date(gameData.datetime.dateTime).toLocaleDateString('en-US', {
        weekday: 'long', month: 'long', day: 'numeric', year: 'numeric',
      })
    : '--';
  const timeStr = gameData?.datetime?.dateTime
    ? new Date(gameData.datetime.dateTime).toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit' })
    : '--';

  return (
    <div className="border border-[#658d71] bg-[rgba(0,0,0,0.12)] p-4">
      <div className="flex items-center justify-between gap-4">
        <TeamSide team={away} label="Away" align="left" />
        <div className="flex flex-col items-center shrink-0 gap-1">
          <span className="text-[#658d71] text-[9px] font-black uppercase tracking-widest">vs</span>
          <span className="text-[#d8ceb3] text-2xl font-black opacity-30">·</span>
          <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest text-center">{timeStr}</span>
        </div>
        <TeamSide team={home} label="Home" align="right" />
      </div>
      <div className="mt-3 pt-3 border-t border-[rgba(101,141,113,0.3)] flex items-center justify-center gap-2 flex-wrap">
        <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest">📍 {venue}</span>
        <span className="text-[#658d71]">·</span>
        <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest">🗓 {dateStr}</span>
      </div>
    </div>
  );
};

const TeamSide = ({ team, label, align }) => (
  <div className={`flex flex-col flex-1 ${align === 'right' ? 'items-end text-right' : 'items-start'}`}>
    <span className="text-[9px] text-[#658d71] font-bold uppercase tracking-widest">{label}</span>
    <span className="text-xl font-black uppercase tracking-widest text-[#d8ceb3] leading-tight">
      {team?.abbreviation || '--'}
    </span>
    <span className="text-[10px] text-[#a9c9b1] font-bold uppercase tracking-wide leading-tight">
      {team?.teamName || '--'}
    </span>
    <span className="text-[9px] text-[#658d71] font-bold mt-0.5">
      {team?.record?.wins ?? '--'}-{team?.record?.losses ?? '--'}
    </span>
  </div>
);

export default MatchupHeader;